import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { splayParams } from "../utils/splay-params";

@Injectable()
export class RoutesEnvironmentsService {
  constructor(private http: HttpClient) {}

  public get(params: any) {
    let projectId;

    [params, projectId] = splayParams(params, "projectId");
    const url = `/api/v5/projects/${projectId}/routes/environments`;

    return this.http
      .get(url, { params })
      .pipe(map((data: any) => data.environments));
  }
}
